import { Component, signal, OnDestroy } from '@angular/core';
import {
  Router, RouterLink,
  NavigationEnd, NavigationCancel, NavigationError,
  RouteConfigLoadStart, RouteConfigLoadEnd,
  GuardsCheckStart, GuardsCheckEnd,
  ResolveStart, ResolveEnd,
  RoutesRecognized,
} from '@angular/router';
import { FikoYTKokBilesenComponent } from '@shared';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

interface UygulamaKarti {
  baslik: string;
  aciklama: string;
  simge: string;
  simgeTuru: 'img' | 'emoji' | 'icon';
  simgeResim?: string;
  routerLink?: any[];
  hariciLink?: string;
  renk: string;
  arkaplanGradient: string;
  yetkiAdi?: string;
}

@Component({
  selector: 'fiko-ana-uygulama',
  imports: [RouterLink, CommonModule],
  templateUrl: './ana-uygulama.component.html',
  standalone: true,
  styleUrl: './ana-uygulama.component.less',
  // Not: Remote provider'lari route seviyesinde veriliyor (app.routes.ts).
  // EnvironmentProviders bileşen provider'ı olamayacağı için burada DEĞİL (NG0207).
})
export class AnaUygulamaComponent extends FikoYTKokBilesenComponent {

 uygulamalar: UygulamaKarti[] = [
    {
      baslik: '3D CAD Sistem',
      aciklama: 'Profesyonel 3D modelleme, STEP import, teknik resim ve ölçüm araçları',
      simge: '🌌',
      simgeTuru: 'img',
      simgeResim: './simgeler/3d.png',
      renk: '#6366f1',
      arkaplanGradient: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    },
    {
      baslik: 'FikoYT Paylaşım',
      aciklama: 'Kart paylaşım sistemi, şablon koleksiyonları ve işbirliği araçları',
      simge: '📢',
      simgeTuru: 'emoji',
      routerLink: ['/paylasim'],
      renk: '#2185d0',
      arkaplanGradient: 'linear-gradient(135deg, #2185d0 0%, #6cb3f5 100%)',
    },
    {
      baslik: 'Soy Ağacı',
      aciklama: 'Aile ağacı görüntüleme, akraba yönetimi ve istatistik araçları',
      simge: '🌳',
      simgeTuru: 'emoji',
      renk: '#10b981',
      arkaplanGradient: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
    },
    {
      baslik: 'Ağ Haritam',
      aciklama: 'Tanıdıkları, akrabaları, iş ağını ve günlük olaylarını haritada parametrik olarak kaydet',
      simge: '🗺️',
      simgeTuru: 'emoji',
      renk: '#6366f1',
      arkaplanGradient: 'linear-gradient(135deg, #6366f1 0%, #0ea5e9 100%)',
    },
    {
      baslik: 'HMI Pano',
      aciklama: 'Fabrika HMI ekranı, NFC kart okuyucu, personel takibi ve üretim istatistikleri',
      simge: '📟',
      simgeTuru: 'emoji',
      routerLink: ['/hmi-pano'],
      renk: '#009688',
      arkaplanGradient: 'linear-gradient(135deg, #00897b 0%, #4db6ac 100%)',
    },
    {
      baslik: 'HMI Pdks',
      aciklama: 'Fabrika HMI ekranı, NFC kart okuyucu, personel takibi ve üretim istatistikleri',
      simge: '💳',
      simgeTuru: 'emoji',
      renk: '#009688',
      arkaplanGradient: 'linear-gradient(135deg, #00897b 0%, #4db6ac 100%)',
    },
    {
      baslik: 'Strafor Kesici',
      aciklama: 'Strafor kütük optimizasyonu, 3D kesim planı ve best-fit yerleştirme',
      simge: '✂️',
      simgeTuru: 'emoji',
      renk: '#f59e0b',
      arkaplanGradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
    },
    {
      baslik: 'Kestel: Son Savunma Hattı',
      aciklama: 'Gerçek harita üzerinde 3D tower defense oyunu — Kestel\'i KELD istilasından koru',
      simge: '🎮',
      simgeTuru: 'emoji',
      renk: '#ef4444',
      arkaplanGradient: 'linear-gradient(135deg, #dc2626 0%, #f97316 100%)',
    },
    {
      baslik: 'Gerçekçi Simülasyon',
      aciklama: 'OSM harita üzerinde 3D şehir, araçlar, yayalar — ultra parametrik gerçekçi simülasyon',
      simge: '🌍',
      simgeTuru: 'emoji',
      renk: '#0ea5e9',
      arkaplanGradient: 'linear-gradient(135deg, #0284c7 0%, #38bdf8 100%)',
    },
    {
      baslik: 'CNC Post Birleştirici',
      aciklama: 'G-Code birleştirme, work offset yönetimi, limit kontrol gezisi ve NC süre analizi',
      simge: '🔧',
      simgeTuru: 'emoji',
      renk: '#7c3aed',
      arkaplanGradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
    },
    {
      baslik: 'AI Asistan',
      aciklama: 'Kendi AI üyeliğini (ChatGPT/Claude/Gemini) bağla; firma verilerinle sohbet edip işlerini hallet',
      simge: '🤖',
      simgeTuru: 'emoji',
      renk: '#6366f1',
      arkaplanGradient: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
    },
    {
      baslik: 'Fiyatlandırma',
      aciklama: 'Paketleri incele, kendi paketini kur, canlı fiyatı gör ve teklif al',
      simge: '💎',
      simgeTuru: 'emoji',
      renk: '#a855f7',
      arkaplanGradient: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
    },
  ];


  // Navigasyon progress - gercek Router event milestone'lari
  yuklenenKart = signal<string | null>(null);
  yuklenmeYuzdesi = signal(0);
  yuklenmeAdimi = signal('');
  indirilenBoyut = signal('');
  private _navSub: Subscription | null = null;
  private _perfObserver: PerformanceObserver | null = null;
  private _toplamIndirilen = 0;

  kartTikla(uygulama: UygulamaKarti) {
    if (this.yuklenenKart()) return;
    if (!uygulama.routerLink) {
      this.nzMessage.info(uygulama.baslik + ' çok yakında bu platformda olacak');
      return;
    }
    this.yuklenenKart.set(uygulama.baslik);
    this.yuklenmeYuzdesi.set(2);
    this.yuklenmeAdimi.set('Baslatiliyor...');
    this.indirilenBoyut.set('');
    this._toplamIndirilen = 0;

    // PerformanceObserver ile gercek chunk download boyutunu takip et
    try {
      this._perfObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          const res = entry as PerformanceResourceTiming;
          // Sadece JS chunk'larini say (lazy loaded modules)
          if (res.initiatorType === 'script' || res.name.endsWith('.js')) {
            this._toplamIndirilen += res.transferSize || res.encodedBodySize || 0;
            this.indirilenBoyut.set(this._boyutFormatla(this._toplamIndirilen));
            this.CD.detectChanges();
          }
        }
      });
      this._perfObserver.observe({ entryTypes: ['resource'] });
    } catch { /* PerformanceObserver desteklenmiyorsa sessiz devam */ }

    // Router event milestone'lari - gercek adimlar
    this._navSub = this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        // Lazy module chunk indiriliyor
        this.yuklenmeYuzdesi.set(10);
        this.yuklenmeAdimi.set('Modul indiriliyor...');
      } else if (event instanceof RouteConfigLoadEnd) {
        // Chunk indirildi, parse ediliyor
        this.yuklenmeYuzdesi.set(50);
        this.yuklenmeAdimi.set('Modul yuklendi');
      } else if (event instanceof RoutesRecognized) {
        // Route eslesti
        this.yuklenmeYuzdesi.set(60);
        this.yuklenmeAdimi.set('Sayfa hazirlaniyor...');
      } else if (event instanceof GuardsCheckStart) {
        this.yuklenmeYuzdesi.set(65);
        this.yuklenmeAdimi.set('Yetki kontrol ediliyor...');
      } else if (event instanceof GuardsCheckEnd) {
        this.yuklenmeYuzdesi.set(75);
      } else if (event instanceof ResolveStart) {
        this.yuklenmeYuzdesi.set(80);
        this.yuklenmeAdimi.set('Veri cozumleniyor...');
      } else if (event instanceof ResolveEnd) {
        this.yuklenmeYuzdesi.set(90);
        this.yuklenmeAdimi.set('Render ediliyor...');
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.yuklenmeYuzdesi.set(100);
        this.yuklenmeAdimi.set(event instanceof NavigationError ? 'Hata!' : 'Tamamlandi');
        this.CD.detectChanges();
        this._temizle();
        setTimeout(() => {
          this.yuklenenKart.set(null);
          this.yuklenmeYuzdesi.set(0);
          this.yuklenmeAdimi.set('');
          this.indirilenBoyut.set('');
          this.CD.detectChanges();
        }, 400);
        return;
      }
      this.CD.detectChanges();
    });

    this.router.navigate(uygulama.routerLink);
  }

  private _temizle() {
    this._navSub?.unsubscribe();
    this._navSub = null;
    this._perfObserver?.disconnect();
    this._perfObserver = null;
  }

  private _boyutFormatla(byte: number): string {
    if (byte < 1024) return byte + ' B';
    if (byte < 1048576) return (byte / 1024).toFixed(0) + ' KB';
    return (byte / 1048576).toFixed(1) + ' MB';
  }

  get erisilebilenUygulamalar(): UygulamaKarti[] {
    const kullanici = this.FikoYT.kimlik.aktifKullaniciJson();
    if (!kullanici) return [];
    return this.uygulamalar.filter(uygulama => {
      if (!uygulama.yetkiAdi) return true;
      return kullanici.uygulamalar?.includes(uygulama.yetkiAdi);
    });
  }

  get herkesAcikUygulamalar(): UygulamaKarti[] {
    return this.uygulamalar.filter(u => !u.yetkiAdi);
  }

  constructor() {
    super();
    this.FikoYT.degisti.subscribe(() => {
      this.CD.detectChanges();
    });
    this.erisimUyarisiGoster();
  }

  private erisimUyarisiGoster() {
    const neden = this.route.snapshot.queryParams['neden'];
    if (!neden) return;
    const mesajlar: Record<string, string> = {
      'abonelik-doldu': 'Firma aboneliÄŸinizin sÃ¼resi dolmuÅŸ. Devam etmek iÃ§in aboneliÄŸi yenileyin.',
      'firma-pasif': 'Bu firma pasif durumda. YÃ¶neticinizle iletiÅŸime geÃ§in.',
    };
    const mesaj = mesajlar[neden];
    if (mesaj) setTimeout(() => this.nzMessage.warning(mesaj, { nzDuration: 6000 }));
  }

  tiklandiDialogKullaniciMenu() { }
}
